<script lang="ts">
    import { cn } from "../cn";
    export let value: string | number = "";
    export let type: "text" | "password" | "email" | "number" | "search" =
        "text";
    export let placeholder: string | undefined = undefined;
    export let required = false;
    export let disabled = false;
    export let minlength: number | undefined = undefined;
    export let id: string | undefined = undefined;
    let className = "";
    export { className as class };

    // Svelte 3 запрещает динамический type на input с bind:value, поэтому
    // явный if/else по типу. Базовый стиль один на всех.
    const base = cn(
        "flex h-9 w-full rounded-lg border border-[var(--input)] bg-[var(--input)]/30 px-3 py-1 text-sm text-[var(--foreground)] placeholder:text-[var(--muted-foreground)] shadow-xs transition-[color,box-shadow] outline-none",
        "focus-visible:border-[var(--primary)]/60 focus-visible:ring-[3px] focus-visible:ring-[var(--primary)]/25",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        className,
    );
</script>

{#if type === "password"}
    <input
        {id}
        type="password"
        {placeholder}
        {required}
        {disabled}
        {minlength}
        bind:value
        on:input
        on:change
        on:keydown
        on:blur
        on:focus
        class={base}
    />
{:else if type === "number"}
    <input
        {id}
        type="number"
        {placeholder}
        {required}
        {disabled}
        bind:value
        on:input
        on:change
        on:keydown
        on:blur
        on:focus
        class={base}
    />
{:else if type === "email"}
    <input
        {id}
        type="email"
        {placeholder}
        {required}
        {disabled}
        {minlength}
        bind:value
        on:input
        on:change
        on:keydown
        on:blur
        on:focus
        class={base}
    />
{:else if type === "search"}
    <input
        {id}
        type="search"
        {placeholder}
        {required}
        {disabled}
        {minlength}
        bind:value
        on:input
        on:change
        on:keydown
        on:blur
        on:focus
        class={base}
    />
{:else}
    <input
        {id}
        type="text"
        {placeholder}
        {required}
        {disabled}
        {minlength}
        bind:value
        on:input
        on:change
        on:keydown
        on:blur
        on:focus
        class={base}
    />
{/if}
